import script from "./LogisticsRules.vue?vue&type=script&lang=ts&setup=true"
export * from "./LogisticsRules.vue?vue&type=script&lang=ts&setup=true"

import "./LogisticsRules.vue?vue&type=style&index=0&id=645bcae7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-645bcae7"]])

export default __exports__